import { defineStore } from 'pinia'
import useApi from '@/composables/useApi'
import { extractErrorMessage } from '@/utils/http'

export const useAppSettingsStore = defineStore('appSettings', {
  state: () => ({
    requireLoginForPublicApp: false,
    isLoaded: false,
    isLoading: false
  }),
  actions: {
    applySettings(payload = {}) {
      this.requireLoginForPublicApp = payload?.requireLoginForPublicApp === true
      this.isLoaded = true
    },
    async loadPublicSettings() {
      if (this.isLoading) return
      this.isLoading = true

      try {
        const response = await useApi().get('/api/v1/app-settings/public')
        this.applySettings(response?.data || {})
        return response
      } catch (error) {
        this.isLoaded = true
        throw new Error(extractErrorMessage(error, 'Could not load app settings.'))
      } finally {
        this.isLoading = false
      }
    },
    async loadAdminSettings() {
      this.isLoading = true

      try {
        const response = await useApi().get('/api/v1/app-settings/admin')
        this.applySettings(response?.data || {})
        return response
      } catch (error) {
        throw new Error(extractErrorMessage(error, 'Could not load app settings.'))
      } finally {
        this.isLoading = false
      }
    },
    async updateAdminSettings(payload = {}) {
      const response = await useApi().patch('/api/v1/app-settings/admin', {
        requireLoginForPublicApp: payload?.requireLoginForPublicApp === true
      })
      this.applySettings(response?.data || {})
      return response
    }
  }
})
